import React from 'react';
import { Node } from '@uncinc/react-drupal-core';

import {
  SliderRelated,
} from '../../../components';

import './style.scss';

const PartnersRelated = ({ entities }) => {
  return (entities && entities.size > 0) && (
    <div className="View PartnersRelated">
      <SliderRelated>
        {entities.map((entity) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const className = 'PartnersRelated__item';
          return (
            <div key={`${uuid}:${langcode}`} className={className}>
              <Node
                id={id}
                key={`${uuid}:${langcode}`}
                isActivePath
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </SliderRelated>
    </div>
  );
};

export default PartnersRelated;
